export interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  items: FAQItem[];
}

export default function FAQ({ items }: FAQProps) {
  if (!items?.length) return null;

  return (
    <section className="my-10">
      <h2 className="mb-4 text-2xl font-bold">Frequently Asked Questions</h2>

      <div className="space-y-3">
        {items.map((item, index) => (
          <details
            key={index}
            className="rounded-lg border p-4 open:bg-gray-50"
          >
            <summary className="cursor-pointer font-medium">
              {item.question}
            </summary>
            <p className="mt-2 text-sm text-gray-700">{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
